<template>
  <div class="setting-view common-view content-view">
    <common-header/>

    <div class="container">

      <h1 class="big-title">Impress design clients with cat-like speed and superhuman creativity.</h1>

      <div class="sub">
        The days of designers starting from scratch are over. Go from beautiful colors to beautiful designs in just a few clicks.<br>
        <br>
        <router-link to="/palette" class="btn medium primary" style="margin-right: 12px">Start with a color palette</router-link>
        <router-link to="/login" class="btn medium secondary" v-if="!isAuthenticated">Log in</router-link>
      </div>

      <div class="sub video">
        <div class="dummy">
          <iframe ref="video" src="https://player.vimeo.com/video/301696655?title=0&byline=0&portrait=0&api=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>
      </div>

      <div class="steps">

        <h2 class="main-title">Custom Starter Kits in 3 easy steps:</h2>

        <div class="items">

          <div class="item">
            <div class="inner">
              <div class="number">1</div>

              <div class="title">Pick a color palette</div>

              <div class="image">
                <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/color-palette-generator_colorful.gif" alt=""/>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="inner">
              <div class="number">2</div>

              <div class="title">Pick a color theme</div>

              <div class="image">
                <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/ui-sample-generator_colorful.gif" alt=""/>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="inner">
              <div class="number">3</div>

              <div class="title">Download your kit</div>

              <div class="image">
                <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/download-sketch.gif" alt=""/>
              </div>
            </div>
          </div>

        </div>

        <div class="actions">
          <router-link to="/palette" class="btn medium primary">
            Start with a color palette
          </router-link>
        </div>

      </div>

      <h2 class="main-title">
        Color Palettes <span class="btn primary small disabled">Free</span>
      </h2>

      <home-palette-tab/>

      <h2 class="main-title">
        Color Themes <span class="btn warning-reverse small disabled">Free with account</span>
      </h2>

      <home-sample-tab/>

      <h2 class="main-title">
        Starter Kits <span class="btn info small disabled">Premium (pay to play)</span>
      </h2>

      <home-kit-tab/>

      <div class="kits">

        <h2 class="main-title">Featured Starter Kits</h2>

        <div class="items image-responsive">
          <router-link
            v-for="(item, index) in styleAssets"
            :key="index"
            :to="`/starterkits/browse/${starterKits[index].id}`"
            class='item'
          >
            <img :src="item['source-url']" alt=""/>
          </router-link>
        </div>

        <router-link to="/starterkits/browse" class="btn medium secondary">
          Browser all Starter Kits
        </router-link>

      </div>

      <div class="plans">

        <h2 class="main-title pad-left">Plans</h2>

        <div class="items">

          <div class="item">
            <div class="inner">
              <div class="title">Free</div>

              <div class="price yellow">
                $0
              </div>

              <div class="description">Generate & save color palettes</div>

              <div class="description">Generate & save color themes</div>

              <div class="description">
                <span class="yellow">4</span> Free starter kits
              </div>
            </div>
          </div>

          <div class="item">
            <div class="inner">
              <div class="title">Premium</div>

              <div class="price green">
                $149/yr
                <div class="hint">per user</div>
              </div>

              <div class="description">Generate & save color palettes</div>

              <div class="description">Generate & save color themes</div>

              <div class="description">
                <span class="green">Unlimited</span> starter kits
              </div>
            </div>
          </div>

          <div class="item">
            <div class="inner">
              <div class="title">Premium<span class="blue">Team</span></div>

              <div class="price blue">
                $99/yr
                <div class="hint">per user, min 2 users</div>
              </div>

              <div class="description">Generate & save color palettes</div>

              <div class="description">Generate & save color themes</div>

              <div class="description">
                <span class="blue">Unlimited</span> starter kits
              </div>
            </div>
          </div>

        </div>

        <div class="actions">
          <router-link to="/register" class="btn medium primary">
            Create a free account
          </router-link>
        </div>

      </div>

      <!--<h2 class="main-title">Designer reactions</h2>-->

      <!--<home-testimonials/>-->

      <h2 class="main-title">Partner API</h2>

      <div class="description">Whether you want to take your website builder color features to the next level or offer advanced personalization with color to your SaaS product customers, we have a wide range of flexible, scalable options for any size organization via our Partner API.</div>

      <div class="action">
        <router-link to="/api" class="btn secondary medium">Learn more</router-link>
      </div>

    </div>

    <app-footer/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HomeKitTab from '../components/home/HomeKitTab';
import HomePaletteTab from '../components/home/HomePaletteTab';
import HomeSampleTab from '../components/home/HomeSampleTab';
import AppFooter from './AppFooter';
import CommonHeader from './CommonHeader';
import { getSession, removeSession } from '../utils/session';
import { sendRequest } from '../utils/api';

export default {
  components: {
    HomeKitTab,
    CommonHeader,
    AppFooter,
    HomeSampleTab,
    HomePaletteTab,
  },
  name: 'modal-home',
  computed: {
    ...mapState(['isAuthenticated']),
  },
  data() {
    return {
      tab: 0,
      video: null,
      playing: false,
      styleAssets: [],
      starterKits: [],
    };
  },
  mounted() {
    this.video = new window.Vimeo.Player(this.$refs.video);
    if (getSession('loggedOut')) {
      removeSession('loggedOut');
      this.addNotification({ message: 'You have logged out!' });
    }
  },
  created() {
    sendRequest('/starter-kit/featured', 'get', { Authorization: getSession('jwtoken') }, {})
      .then((response) => {
        this.starterKits = response.data['starter-kits'];

        this.platforms = [];
        for (let i = 0; i < this.starterKits.length; i++) {
          const { platform } = this.starterKits[i];
          let isIn = false;
          let j;
          for (j = 0; j < this.platforms.length; j++) {
            if (this.platforms[j].title === platform) {
              isIn = true;
              break;
            }
          }

          if (isIn) {
            this.platforms[j].count += 1;
          } else {
            this.platforms.push({
              title: platform,
              count: 1,
            });
          }
        }

        // get previews for all tab
        const promiseArray = [];
        for (let i = 0; i < this.starterKits.length; i++) {
          promiseArray.push(sendRequest(
            `/theme-assets/svg/${this.starterKits[i]['preview-asset-ids'][0]}?key=000&secret=000`,
            'get',
            {},
            {},
          ));
        }

        Promise.all(promiseArray)
          .then((assets) => {
            this.styleAssets = assets.map(asset => asset.data);
          })
          .catch(err => console.log(err));
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapActions(['toggleHome']),
    ...mapActions('notification', [
      'addNotification',
    ]),
    play() {
      this.video.play();
      this.playing = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/_home';
</style>
